// Nuxt 4 auto-imports `export default class X` under its declaration name, which Rolldown then
// cannot resolve, so classes in utils/ have to be named exports.
export class TimeoutError extends Error {
	override name = 'TimeoutError';

	constructor(ms?: number) {
		super(`Timed out${typeof ms === 'undefined' ? '' : ` after ${ms}ms`}.`);
	}
}
